import { GetAsync } from "../actions"

export const getPendingIndexation= async (tenantId)=>{
    return GetAsync({tenantId},"Tenant/GetPendingIndexation");
}